import { Link } from "react-router-dom";
import { Zap, Phone, Mail, MapPin } from "lucide-react";
import { SITE } from "@/lib/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0A1128] text-slate-300 mt-24">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 md:py-20 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <span className="flex items-center justify-center w-9 h-9 rounded-md bg-[#FF6B00] text-white">
              <Zap className="w-5 h-5" strokeWidth={2.5} />
            </span>
            <span className="font-display font-black text-xl text-white">Care for Elektra</span>
          </div>
          <p className="text-slate-400 max-w-md leading-relaxed">
            Erkend en gecertificeerd elektricien. Actief in Vlaardingen en alles binnen een straal van 25 km.
            Veiligheid, kwaliteit en strak kabelmanagement staan voorop.
          </p>
          <div className="mt-5 flex flex-wrap gap-2">
            {SITE.certifications.map((c) => (
              <span
                key={c}
                className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-white/5 border border-white/10 text-[11px] font-semibold text-slate-300"
              >
                <span className="w-1.5 h-1.5 rounded-full bg-[#FF6B00]" />
                {c}
              </span>
            ))}
          </div>
          <p className="mt-5 text-xs text-slate-500">KvK: {SITE.kvk}</p>
          <p className="text-xs text-slate-500">BTW: {SITE.btw}</p>
        </div>

        <div>
          <h4 className="font-display font-bold text-white mb-4">Diensten</h4>
          <ul className="space-y-2 text-sm">
            <li><Link className="hover:text-[#FF6B00]" to="/diensten#groepenkasten">Groepenkasten & Meterkasten</Link></li>
            <li><Link className="hover:text-[#FF6B00]" to="/diensten#smart-home">Smart Home & Domotica</Link></li>
            <li><Link className="hover:text-[#FF6B00]" to="/diensten#laadpalen">Laadpalen (EV)</Link></li>
            <li><Link className="hover:text-[#FF6B00]" to="/diensten#allround">Allround Elektrawerk</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-white mb-4">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2">
              <Phone className="w-4 h-4 mt-1 text-[#FF6B00]" />
              <a href={`tel:${SITE.phoneIntl}`} className="hover:text-white" data-testid="footer-phone">
                {SITE.phoneDisplay}
              </a>
            </li>
            <li className="flex items-start gap-2">
              <Mail className="w-4 h-4 mt-1 text-[#FF6B00]" />
              <a href={`mailto:${SITE.email}`} className="hover:text-white" data-testid="footer-email">
                {SITE.email}
              </a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin className="w-4 h-4 mt-1 text-[#FF6B00]" />
              <span>{SITE.region}</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-5 flex flex-col md:flex-row items-start md:items-center justify-between gap-2 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} Care for Elektra. Alle rechten voorbehouden.</p>
          <p>Erkend & Gecertificeerd Installateur</p>
        </div>
      </div>
    </footer>
  );
}
